module.exports = __webpack_public_path__ + "fonts/montserrat-latin-300-normal.a113f0d.woff2";